<template>
  <div>
    <nav-breadcrumb :menu="[{label: '授信记录'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="contractListColumns"
        :filters="filters"
        :pageSize.sync="pageSize"
        :page.sync="page"
        class="xzmLR10"
      ></data-table>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import moment from 'moment'
  import {xmlBuildQuery} from "../../../filters/CommonActions";
  import {formatMoney} from "../../../filters/CommonFilters";

  export default {
    name: 'ServerAdminCreditList',
    data() {
      return {
        page: 1,
        pageSize: 10,
        listData: {},
        filters: {
          form: {

          },
          columns: [
            {
              label: '客户名称',
              component: 'el-input',
              field: 'u__customerName'
            },
            {
              label: '贷款产品',
              component: 'el-input',
              field: 'p__productName'
            },
            {
              label: '授信日期',
              component: 'date-range-picker',
              field: 'cr__createdDate',
              op: ['gteq', 'lteq']
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getCustomerCreditList()
          }
        }
      }
    },
    computed : {
      customerId: function() {
        return this.$route.query['c.customerId'] || ''
      },
      contractListColumns: function() {
        return [
         /* {
            name: '授信编号',
            field: 'cr__creditId'
          },*/
          {
            name: '客户名称',
            field: 'u__customerName'
          },
          {
            name: '贷款产品',
            field: 'p__productName',
          },
          {
            name: '授信额度(元)',
            field: 'cr__lineOfCredit',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          /*{
            name: '授信起始日期',
            field: 'cr__creditValidity1',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')formatMoney
            }
          },
          {
            name: '授信截止日期',
            field: 'cr__creditValidity2',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD')
            }
          },*/
          {
            label: '授信时间',
            field: 'cr__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          },
          {
            name: '操作',
            opts:
              [
                {
                  class: 'el-icon-info',
                  name: '查看详情',
                  clickHandler: (index, row)=>{
                    this.viewDetail(index, row)
                  },
                },
                /*{
                  class: 'el-icon-edit',
                  name: '编辑授信',
                  clickHandler: (index, row)=>{
                    this.editCredit(index, row)
                  },
                },*/
              ]

          }
        ]
      },
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'cr.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getCustomerCreditList()
      },
      '$route.query': function (newVal) {
        this.getCustomerCreditList()
      }
    },
    mounted() {
      this.getCustomerCreditList()
    },
    methods: {
      getCustomerCreditList: function () {
        if(this.customerId!=''){
          xhr.getCustomerCreditList(
            Object.assign({}, {'xlist.search.cr.customerId':this.customerId,'xlist.search.cr.customerId.op':'eq'},this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
              } catch (e) {

              }
            })
        }else {
          xhr.getCustomerCreditList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
              } catch (e) {

              }
            })
        }
      },
      viewDetail: function (index, row) {
        try {
          this.$router.push({path: 'Detail?cr.creditId='+ row.cr__creditId})
        }
        catch (e) {

        }
      },
      editCredit: function (index, row) {
        try{
          this.$router.push({path: 'Edit?cr.creditId='+ row.cr__creditId})

        }catch (e) {

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/CreditList.vue